import * as actions from '../actions/newApplication';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';


export function requestGetApplicationByIdAfterApplicationUpdate(sources) {
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_UPDATE)
		.map(action => ({
			url: BASE_URL + 'api/Applications/Forms/' + action.payload.applicationId  ,
			category: 'requestGetApplicationByIdAfterApplicationUpdate',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('requestGetApplicationByIdAfterApplicationUpdate')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.map(response => response.status === 200
			? actions.fetchApplicationByIdAfterApplicationUpdateSuccess(response.body)
			: actions.fetchApplicationByIdAfterApplicationUpdateFailed(response)
		);

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function requestGetApplicationByIdAfterApplicationAnswerUpdate(sources) {
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_ANSWER_UPDATE)
		.map(action => ({
			url: BASE_URL + 'api/Applications/Forms/' + action.payload.applicationId  ,
			category: 'requestGetApplicationByIdAfterApplicationAnswerUpdate',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('requestGetApplicationByIdAfterApplicationAnswerUpdate')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.fetchApplicationByIdAfterApplicationAnswerUpdateSuccess(response.body));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function requestGetApplicationByIdAfterApplicationAnswerUpdateFailed(sources) {
	let httpResponse$ = sources.HTTP
		.select('requestGetApplicationByIdAfterApplicationAnswerUpdate')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.fetchApplicationByIdAfterApplicationAnswerUpdateFailed(response));

	return {
		ACTION: httpResponse$
	};
}



export function requestUpdateFormQuestionAnswerAfterSubmit(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.UPDATE_FORM_QUESTION_ANSWER_AFTER_SUBMIT)
        .map(action => ({
            url: BASE_URL + 'api/Applications/ApplicationAnswers',
            category: 'requestUpdateFormQuestionAnswerAfterSubmit',
            method: 'PUT',
            send: action.payload.sendBody,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestUpdateFormQuestionAnswerAfterSubmit')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.updateFormQuestionAnswerAfterSubmitSuccess(response.body));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestUpdateFormQuestionAnswerAfterSubmitFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestUpdateFormQuestionAnswerAfterSubmit')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.updateFormQuestionAnswerAfterSubmitFail(response));

    return {
        ACTION: httpResponse$
    };
}


export function getSubCaseTypesSelectedApplication(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_SUB_CASE_TYPE)
		.map(action => ({
			url: BASE_URL + 'api/CaseTypes/CaseTypes/' + action.payload  ,
			category: 'fetSubCaseTypesSelectedApplication',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('fetSubCaseTypesSelectedApplication')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveSubCaseTypesSelectedApp(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function deleteApplication(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_DELETE_DRAFTED_APPLICATION)
		.map(action => ({
			url: BASE_URL + 'api/Applications/Forms/' + action.payload  ,
			category: 'deleteApplication',
			method: 'DELETE',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('deleteApplication')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveDeleteDraftedApplicationResponse(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function getSelectedApplication(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_SELECTED_APPLICATION || (action.type === ActionTypes.GET_APPLICATION_POLICY_AFTER_AD_CREATE))
		.map(action => ({
			url: BASE_URL + 'api/Applications/Forms/' + action.payload  ,
			category: 'getSelectedApplication',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getSelectedApplication')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetSelectedApplication(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function badResponseGetSelectedApp(sources) {
	let httpResponse$ = sources.HTTP
		.select('getSelectedApplication')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestGetSelectedApplication());

	return {
		ACTION: httpResponse$
	};
}

export function getApplication(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_APPLICATION)
		.map(action => ({
			url: BASE_URL + 'api/Applications/Forms/' + action.payload.caseTypeId + '/' + action.payload.subCaseTypeId  ,
			category: 'getApplication',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getApplication')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetApplication(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestGetApplication(sources) {
	let httpResponse$ = sources.HTTP
		.select('getApplication')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestGetApplication(response));

	return {
		ACTION: httpResponse$
	};
}

export function postNewApplication(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_POST_NEW_APPLICATION)
		.map(action => ({
			url: BASE_URL + `api/Applications/Forms`,
			category: 'postNewApplication',
			method: 'POST',
			send: action.payload,
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('postNewApplication')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 201)
		.map(response => actions.receivePostNewApplication(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestPostNewApp(sources) {
	let httpResponse$ = sources.HTTP
		.select('postNewApplication')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 201)
		.map(response => actions.receiveBadRequestPostNewApp(response));

	return {
		ACTION: httpResponse$,
	};
}

export function requestPatchApplication(sources){
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_PATCH_APPLICATION)
		.map(action => ({
			url: BASE_URL + 'api/Applications/Forms/' + action.payload.id,
			category: 'patchApplication',
			method: 'PATCH',
			send: action.payload,
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('patchApplication')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receivePatchApplication(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function badRequestPatchApplication(sources) {
	let httpResponse$ = sources.HTTP
		.select('patchApplication')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestPatchApplication(response));

	return {
		ACTION: httpResponse$
	};
}

//Solicitor user: Get all the work sources of his solicitor Solicitor Group
export function getSolicitorGroupWorkSources(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_SOLICITOR_GROUP_WORKSOURCES)
		.map(action => ({
			url: BASE_URL + 'api/groups/'+action.payload+'/workSources/',
			category: 'getSolicitorGroupWorkSources',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getSolicitorGroupWorkSources')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetSolicitorGroupWorkSources(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestGetSolicitorGroupWorkSources(sources) {
	let httpResponse$ = sources.HTTP
		.select('getSolicitorGroupWorkSources')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestGetSolicitorGroupWorkSources(response));

	return {
		ACTION: httpResponse$
	};
}

export function getPolicyAsSolicitor(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.GET_POLICY_AS_SOLICITOR)
		.map(action => ({
			url: BASE_URL + 'api/Applications/Forms/'+ action.payload.caseTypeId + "/" +
			 action.payload.subCaseTypeId + "/applicationUser/" + action.payload.userId,
			category: 'getPolicyAsSolicitor',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getPolicyAsSolicitor')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetApplication(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestGetPolicyAsSolicitor(sources) {
	let httpResponse$ = sources.HTTP
		.select('getPolicyAsSolicitor')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestGetApplication(response));

	return {
		ACTION: httpResponse$
	};
}

export function postNewApplicationAsSolicitor(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_POST_NEW_APPLICATION_AS_SOLICITOR)
		.map(action => ({
			url: BASE_URL + `api/Applications/Forms/applicationUser/`+ action.payload.application.userId ,
			category: 'postNewApplicationAsSolicitor',
			method: 'POST',
			send: action.payload.application.sendBody,
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('postNewApplicationAsSolicitor')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 201)
		.map(response => actions.receivePostNewApplication(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestPostNewAppAsSolicitor(sources) {
	let httpResponse$ = sources.HTTP
		.select('postNewApplicationAsSolicitor')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 201)
		.map(response => actions.receiveBadRequestPostNewApp(response));

	return {
		ACTION: httpResponse$,
	};
}